import OwnerChatEvents from './OwnerChatEvents';
export default OwnerChatEvents;